import { Button, Layout } from 'antd';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { Logo } from '@shared/ui';
import { useUserStore } from '@entities/user';
import { LegalFooter } from '@widgets/legal-footer';

const { Header, Content } = Layout;

/**
 * Layout для публичных страниц без авторизации (тарифы, политика,
 * соглашение, реквизиты). Видны и анониму, и залогиненному юзеру.
 *
 * Шапка: лого слева, справа кнопка «Войти» (для анонима) или
 * «В кабинет» (для залогиненного).
 *
 * Footer — общий LegalFooter (тот же что в CabinetLayout).
 */
export function LegalLayout() {
  const navigate = useNavigate();
  const user = useUserStore((s) => s.user);

  return (
    <Layout style={{ minHeight: '100vh', background: '#F9FAFB' }}>
      <Header
        style={{
          background: '#FFFFFF',
          borderBottom: '1px solid #E5E7EB',
          padding: '0 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: 64,
        }}
      >
        <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
          <Logo width={110} />
        </Link>
        {user ? (
          <Button onClick={() => navigate('/')}>В кабинет</Button>
        ) : (
          <Button onClick={() => navigate('/login')}>Войти</Button>
        )}
      </Header>

      <Content style={{ padding: '32px 24px' }}>
        <Outlet />
      </Content>

      <LegalFooter />
    </Layout>
  );
}
